var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForwardSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.53914 8C10.9086 10.1961 12.8665 11.7012 15.6524 14.3372L15.9024 14.5742V16.1003L15.6524 16.3372C12.8665 18.9733 10.9086 20.4784 7.53914 22.6745L6.66675 21.3333C9.86503 19.2488 11.7271 17.8239 14.3035 15.4063V15.2669C11.7275 12.8496 9.86476 11.4255 6.66675 9.34115L7.53914 8ZM16.2058 8C19.5753 10.1961 21.5332 11.7012 24.3191 14.3372L24.5691 14.5742V16.1003L24.3191 16.3372C21.5332 18.9733 19.5753 20.4784 16.2058 22.6745L15.3334 21.3333C18.5317 19.2488 20.3938 17.8239 22.9701 15.4063V15.2669C20.3941 12.8496 18.5314 11.4255 15.3334 9.34115L16.2058 8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardSmall);
export default __webpack_public_path__ + "static/media/arrow-forward-small.612f1027361a56c9ff75b5ad2a0f47a8.svg";
export { ForwardRef as ReactComponent };